import it from "../translations/it.json";
import en from "../translations/en.json";

export const dictionaryList = { en, it };

export const languageOptions = {
  en: "English",
  it: "Italiano",
};
export const siteLanguageMap = {
  it: "it",
  en: "en",
  default: "en",
};

export const isoLanguageMap = {
  it: "it",
  en: "en",
};

export const isoCountryMap = {
  it: "it-IT",
  en: "en-UK",
};

export const siteLanguageMapNumeric = {
  it: 2,
  en: 1,
  default: 2,
};
